//基础信息
export default [{
  path: '/mallClassifyManage',
  component: resolve => require(['../pages/shoppingMallManage/mallClassifyManage.vue'], resolve),
  name: 'MallClassifyManage',
  title: "商品分类管理",
  meta: {
    title: "商品分类管理"
  }
},
  {
    path: '/goodsManage',
    component: resolve => require(['../pages/shoppingMallManage/goodsManage.vue'], resolve),
    name: 'Goods',
    title: "商品管理",
    meta: {
      title: "商品管理"
    }
  },
  {
    path: '/rentGoodsManage',
    component: resolve => require(['../pages/shoppingMallManage/rentGoodsManage.vue'], resolve),
    name: 'RentGoods',
    title: "租赁商品",
    meta: {
      title: "租赁商品"
    }
  },
  {
    path: '/rentOrder',
    component: resolve => require(['../pages/shoppingMallManage/rentOrder.vue'], resolve),
    name: 'RentOrder',
    title: "租赁订单",
    meta: {
      title: "租赁订单"
    }
  },
  {
    path: '/rentCenter',
    component: resolve => require(['../pages/shoppingMallManage/rentCenter.vue'], resolve),
    name: 'RentCenter',
    title: "租赁中心",
    meta: {
      title: "租赁中心"
    }
  },
  {
    path: '/commodityAttr',
    component: resolve => require(['../pages/shoppingMallManage/commodityAttr.vue'], resolve),
    name: 'Commodityattr',
    title: "属性规格管理",
    meta: {
      title: "属性规格管理"
    }
  },
  {
    path: '/logisticsManage',
    component: resolve => require(['../pages/shoppingMallManage/logisticsManage.vue'], resolve),
    name: 'LogisticsMag',
    title: "物流公司管理",
    meta: {
      title: "物流公司管理"
    }
  },
  {
    path: '/logisticsSet',
    component: resolve => require(['../pages/shoppingMallManage/logisticsSet.vue'], resolve),
    name: 'LogisticsSet',
    title: "设置物流运费",
    meta: {
      title: "设置物流运费"
    }
  },
  {
    path: '/order',
    component: resolve => require(['../pages/shoppingMallManage/order.vue'], resolve),
    name: 'order',
    title: "订单管理",
    meta: {
      title: "订单管理"
    }
  },
  {
    path: '/evaluate',
    component: resolve => require(['../pages/shoppingMallManage/evaluate.vue'], resolve),
    name: 'evaluate',
    title: "评价管理",
    meta: {
      title: "评价管理"
    }
  },
  {
    path: '/recoShop',
    component: resolve => require(['../pages/shoppingMallManage/recoShop.vue'], resolve),
    name: 'recoShop',
    title: "商品推荐",
    meta: {
      title: "商品推荐"
    }
  },
  {
    path: '/ticketsOrder',
    component: resolve => require(['../pages/shoppingMallManage/ticketsOrder.vue'], resolve),
    name: 'ticketsOrder',
    title: "门票订单管理",
    meta: {
      title: "门票订单管理"
    }
  },
  {
    path: '/ticketsManage',
    component: resolve => require(['../pages/shoppingMallManage/ticketsManage.vue'], resolve),
    name: 'ticketsManage',
    title: "会员等级",
    meta: {
      title: "门票管理"
    }
  },
];
